import { useContext } from "react";
import { AuthContext } from "../services/AuthContext";

/**
 * useAuth — consumer hook for AuthContext. Always pair with <AuthProvider>.
 *
 * Returns:
 *  - user          : decoded JWT payload { sub, roles, exp, ... } or null
 *  - userToken     : raw JWT string or null
 *  - loading       : true while initial token read is in progress
 *  - login(token)  : persist token and mark authenticated
 *  - logout()      : clear token and redirect to /
 *  - hasRole(role) : boolean check for a single role
 *  - hasAnyRole(...roles) : boolean OR across roles
 */
export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) {
    throw new Error("useAuth must be used inside <AuthProvider>");
  }
  return ctx;
}

/** Convenience hook: true iff the current user has at least one of the roles. */
export function useHasRole(...roles) {
  const { hasAnyRole } = useAuth();
  return hasAnyRole(...roles);
}
